import { computed, defineComponent, ref } from 'vue';
import { useStore } from 'vuex';
import { useSweetAlert } from '@/composables/sweetalert';
import { EmergencyAction, EmergencyGetter } from '@/store/emergency/emergency.module';
import { Emergency, EmergencyAttachment } from '@/store/emergency/emergency.model';
import BaseModalComponent from '@/components/baseModal/BaseModal.vue';

export default defineComponent({
  name: 'EmergencyImageModalComponent',
  components: {
    BaseModalComponent,
  },
  props: {
    emergencyId: {
      type: Number,
    },
  },
  setup: (props) => {
    const store = useStore();
    const swal = useSweetAlert();
    const emergency = computed<Emergency | undefined>(() => store.getters[EmergencyGetter.BY_ID](props.emergencyId));
    const images = computed<EmergencyAttachment[]>(() => (emergency.value?.emergencyAttachments) ? emergency.value?.emergencyAttachments.filter(m => m.attachmentType.id === 2) : []);
    const isLoading = computed(() => store.getters[EmergencyGetter.STATUS] === 'init' || store.getters[EmergencyGetter.STATUS] === 'loading');
    const imageModal = ref<InstanceType<typeof BaseModalComponent>>();
    const fileDialog = ref<HTMLInputElement>();

    // show modal
    const show = () => {
      imageModal.value?.show();
    };

    // hide modal
    const hide = () => {
      imageModal.value?.hide();
    };

    // open file dialog
    const fileDialogOpen = () => {
      fileDialog.value?.click();
    };

    const fileDialogChange = () => {
      const files = fileDialog.value?.files as FileList;
      store.dispatch(EmergencyAction.ADD_ATTACHMENTS, {
        id: emergency.value?.id,
        attachmentTypeId: 2,
        names: Array(files.length).fill('image'),
        attachments: files,
      });
    };

    const deleteImage = (id: number) => {
      swal.confirm('ลบข้อมูล!', 'คุณต้องการลบข้อมูลใช่หรือไม่?', 'ใช่ ลบเดี๋ยวนี้!', '#dc3545')
        .then((result) => {
          if (result.isConfirmed) {
            store.dispatch(EmergencyAction.REMOVE_ATTACHMENTS, {
              id: emergency.value?.id,
              attachmentIds: [id],
            });
          }
        });
    };

    return {
      images,
      imageModal,
      fileDialog,
      isLoading,
      show,
      hide,
      fileDialogOpen,
      fileDialogChange,
      deleteImage,
    };
  }
});
